import "./StAlbansClinic.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import BatchwoodLocation from "./sections/BatchwoodLocation";
import Services from "./sections/Services";
import DecisionGuide from "./sections/DecisionGuide";
import PhysiotherapyPricing from "./sections/PhysiotherapyPricing";
import MassagePricing from "./sections/MassagePricing";
import GaitPricing from "./sections/GaitPricing";
import PartnershipCallout from "./sections/PartnershipCallout";
import MetabolicTesting from "./sections/MetabolicTesting";
import CareProcess from "./sections/CareProcess";
import VisitProcess from "./sections/VisitProcess";
import WhyChooseUs from "./sections/WhyChooseUs";
import StAlbansCta from "./sections/StAlbansCta";
import Footer from "@/reusable_sections/Footer";
export default function StAlbansClinicPage() {
  return <div>
      <Header />
      <Hero />
      <BatchwoodLocation />
      <Services />
      <DecisionGuide />
      <PhysiotherapyPricing />
      <MassagePricing />
      <GaitPricing />
      <PartnershipCallout />
      <MetabolicTesting />
      <CareProcess />
      <VisitProcess />
      <WhyChooseUs />
      <StAlbansCta />
      <Footer />
    </div>;
}